import { ReactNode } from 'react';
import { DashboardContextProvider } from './DashboardContext';
import { RAIContextProvider } from './RAIContext';
import { LeaderboardContextProvider } from './LeaderboardContext';
import { PromptLibraryContextProvider } from './PromptLibraryContext';
import { PromptPlaygroundContextProvider } from './PromptPlayGroundContext';
import { PromptProvider } from './PromptContextType';

type ContextProviderProps = {
  children: ReactNode;
};
const ContextProvider = ({ children }: ContextProviderProps) => {
  return (
    <PromptProvider>
      <DashboardContextProvider>
        <RAIContextProvider>
          <LeaderboardContextProvider>
            <PromptLibraryContextProvider>
              <PromptPlaygroundContextProvider>{children}</PromptPlaygroundContextProvider>
            </PromptLibraryContextProvider>
          </LeaderboardContextProvider>
        </RAIContextProvider>
      </DashboardContextProvider>
    </PromptProvider>
  );
};
export default ContextProvider;
